import { createAsyncThunk, createSlice } from '@reduxjs/toolkit';
import { AxiosError } from 'axios';

import api from '../../../api/axios';
import { IApiResponseError, IApiState } from '../../../types/api';
import { RootState } from '../..';

interface IResetPinRequest {
  phoneNumberVerificationId: string;
  pin: string;
}

export interface IResetPinResponse {
  status?: boolean;
  message?: string;
  data?: unknown;
  errors?: IApiResponseError[];
}

const initialState: IApiState<IResetPinResponse> = {
  value: null,
  status: 'idle',
  error: '',
};

export const resetPinAsync = createAsyncThunk(
  'pin/reset',
  async (values: IResetPinRequest, { rejectWithValue, dispatch, getState }) => {
    try {
      const state = getState() as RootState;

      const accessToken = state.auth.value?.data?.token?.accessToken;

      const businessId =
        localStorage.getItem('businessId') ||
        state.auth.value?.data?.user?.businesses?.[0]?.id;

      const config = {
        headers: {
          Authorization: `Token ${accessToken}`,
          'X-Business-Id': businessId,
        },
      };

      const { data } = await api.put<IResetPinResponse>(
        `/auth/reset-pin`,
        values,
        config
      );

      return data;
    } catch (err) {
      const error = err as AxiosError<IResetPinResponse>;

      return rejectWithValue(error.response?.data);
    }
  }
);

export const pinResetSlice = createSlice({
  name: 'pin/reset',
  initialState,
  reducers: {
    resetPinReset(state) {
      state.value = null;
      state.status = 'idle';
      state.error = '';
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(resetPinAsync.pending, (state) => {
        state.status = 'loading';
        state.error = '';
      })
      .addCase(resetPinAsync.fulfilled, (state, action) => {
        state.status = 'success';
        state.value = action.payload as IResetPinResponse;
      })
      .addCase(resetPinAsync.rejected, (state, action) => {
        state.status = 'failed';
        state.value = action.payload as IResetPinResponse;
        state.error = action.error.message;
      });
  },
});

export const { resetPinReset } = pinResetSlice.actions;

export default pinResetSlice.reducer;
